import { useGlobalData } from "@/app/global_data"
import { getValueForMetric } from "@/app/metric_utils"
import { RawHTML } from "@/app/raw_html"
import { Entity, Formatter } from "@/app/types"
import {
  getDeltaColorClass,
  getDeltaValueFromComparison,
} from "@/components/comparison_group_list/comparison_group_list.functions"
import { ComparisonGroupTableRowProps } from "@/components/comparison_group_list/types"

export function TableRow({
  member,
  memberId,
  onClick,
  term,
  metric,
  showDelta,
  comparisonValue,
}: ComparisonGroupTableRowProps) {
  const globalData = useGlobalData()
  const { entity } = globalData.get()

  const isMemberGlobalEntity =
    entity.isFund() ?
      entity.getId() === member.fund?.fundId
    : entity.getId() === member.firm?.firmId

  const formatters = Formatter.getFormatter(metric.name, "TABLE", true)
  const memberEntity = new Entity(member[entity.propertyName()])
  const val = getValueForMetric(member, false, null, term.key, metric.name)
  const ticker = memberEntity.isFund() ? memberEntity.getFund().ticker : null
  const isMemberIncludedInFilteredData =
    "filterIncluded" in member ? member.filterIncluded : true

  // delta value and formatted string
  const deltaValue = getDeltaValueFromComparison(val, comparisonValue)
  const hasValidDelta = typeof deltaValue === "number"
  const formattedDeltaValue = hasValidDelta ? formatters(deltaValue) : ""
  const deltaPrefix = hasValidDelta && deltaValue > 0 ? "+" : ""

  return (
    <tr
      className={`flex justify-between even:bg-main-100
        ${isMemberGlobalEntity ? "text-primary-500" : ""}
        ${isMemberIncludedInFilteredData ? "" : "text-main-300"}`}>
      <td className="cursor-pointer overflow-y-scroll whitespace-nowrap px-3 py-1.5">
        {member["rank"] ?? ""}
      </td>
      <td
        onClick={onClick}
        id={memberId}
        className="flex-1 cursor-pointer overflow-y-scroll whitespace-nowrap px-3 py-1.5">
        {memberEntity.getName()}
        {ticker ? ` (${ticker})` : ""}
      </td>
      <td
        key={`${memberId}-${metric.name}`}
        className="right-0 whitespace-nowrap px-3 py-1 text-right">
        {!showDelta && (
          <RawHTML>{val !== null ? formatters(val) : "-"}</RawHTML>
        )}
        {hasValidDelta && showDelta && (
          <div className="flex items-center justify-end">
            <span className={`${getDeltaColorClass(deltaValue)}`}>
              {deltaPrefix}
              <RawHTML>{formattedDeltaValue}</RawHTML>
            </span>
          </div>
        )}
      </td>
    </tr>
  )
}
